import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextPageMessage: {
        id: 'endorsement.eh.insuredDetailsPage.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    lossOccurredAfterChangeEffectiveDate: {
        id: 'endorsement.eh.insuredDetailsPage.Loss Occurred After Change Effective Date',
        defaultMessage: 'A loss for this risk occurred on or after the effective date of the change?'
    },
    lossOccurredAfterChangeEffectiveDateYes: {
        id: 'endorsement.eh.insuredDetailsPage.Loss Occurred After Change Effective Date.Yes',
        defaultMessage: 'Yes'
    },
    lossOccurredAfterChangeEffectiveDateNo: {
        id: 'endorsement.eh.insuredDetailsPage.Loss Occurred After Change Effective Date.No',
        defaultMessage: 'No'
    },
    policyInformation: {
        id: 'endorsement.eh.insuredDetailsPage.Policy Information',
        defaultMessage: 'Policy Information'
    },
    lineOfBusiness: {
        id: 'endorsement.eh.insuredDetailsPage.Line Of Business',
        defaultMessage: 'Line Of Business'
    },
    periodStartDate: {
        id: 'endorsement.eh.insuredDetailsPage.Effective Date',
        defaultMessage: 'Effective Date'
    },
    periodEndDate: {
        id: 'endorsement.eh.insuredDetailsPage.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    rateAsOfDate: {
        id: 'endorsement.eh.insuredDetailsPage.Rate as of Date',
        defaultMessage: 'Rate as of Date'
    },
    riskState: {
        id: 'endorsement.eh.insuredDetailsPage.Risk State',
        defaultMessage: 'Risk State'
    },
    policyType: {
        id: 'endorsement.eh.insuredDetailsPage.Policy Type',
        defaultMessage: 'Policy type'
    },
    insuredInfo: {
        id: 'endorsement.eh.insuredDetailsPage.Insured Information',
        defaultMessage: 'Insured Information'
    },
    insuredFirstName: {
        id: 'endorsement.eh.insuredDetailsPage.insuredInformation.FirstName',
        defaultMessage: 'First Name'
    },
    insuredMiddleName: {
        id: 'endorsement.eh.insuredDetailsPage.insuredInformation.M.I.',
        defaultMessage: 'M.I.'
    },
    insuredLastName: {
        id: 'endorsement.eh.insuredDetailsPage.insuredInformation.LastName',
        defaultMessage: 'Last Name'
    },
    insuredSuffix: {
        id: 'endorsement.eh.insuredDetailsPage.insuredInformation.Suffix',
        defaultMessage: 'Suffix'
    },
    insuredSSN: {
        id: 'endorsement.eh.insuredDetailsPage.insuredInformation.Social Security Number',
        defaultMessage: 'Social Security Number'
    },
    insuredAddress: {
        id: 'endorsement.eh.insuredDetailsPage.Insured Residence Information',
        defaultMessage: 'Insured Residence Address'
    },
    insuredAddressAddressLine1: {
        id: 'endorsement.eh.insuredDetailsPage.insuredAddress.Address Line 1',
        defaultMessage: 'Address Line 1'
    },
    insuredAddressAddressLine2: {
        id: 'endorsement.eh.insuredDetailsPage.insuredAddress.Address Line 2',
        defaultMessage: 'Address Line 2'
    },
    insuredAddressAddressCity: {
        id: 'endorsement.eh.insuredDetailsPage.insuredAddress.City',
        defaultMessage: 'City'
    },
    insuredAddressAddressZipCode: {
        id: 'endorsement.eh.insuredDetailsPage.insuredAddress.ZipCode',
        defaultMessage: 'Zip Code'
    },
    insuredAddressAddressState: {
        id: 'endorsement.eh.insuredDetailsPage.insuredAddress.State',
        defaultMessage: 'State'
    },
    addNewPni: {
        id: 'endorsement.eh.insuredDetailsPage.pni.Add New Pni',
        defaultMessage: 'Add New Pni'
    },
    locationCodeHelpText: {
        id: 'endorsement.eh.insuredDetailsPage.mailingAndBillingAddress.Location Code(s) available. Contact MSA at FOSCLicensing@MSAGROUP.COM to request updates.',
        defaultMessage: 'Location Code(s) available. Contact MSA at FOSCLicensing@MSAGROUP.COM to request updates.'
    },
    lossOccurredAfterEffectiveDate: {
        id: "endorsement.eh.insuredDetailsPage.Has any Liability Loss occurred in the household between the effective date and today's date?",
        defaultMessage: "Has any Liability Loss occurred in the household between the effective date and today's date?"
    }
});
